module.exports = __webpack_public_path__ + "img/stock1.4ebb5807.png";